<template>
  <v-btn
    class="ma-2 rounded-lg"
    :color="color"
    small
    :disabled="disabled"
    :loading="loading"
    @click="$emit('action')"
  >
    <v-icon small class="mr-2">{{ icon }}</v-icon>
    {{ label }}
  </v-btn>
</template>

<script>
export default {
  name: "ActionButton",

  props: ["color", "icon", "label", "disabled", "loading"]
};
</script>
